<div class="login-navbar" role="banner">
  <div class="container">
    <mat-toolbar class="login-navbar__toolbar p-0">
      <div class="login-navbar__bar">
        <div class="login-navbar__left">
          <a routerLink="/bb-login" class="login-navbar__logo-link" aria-label="Go to login page">
            <img src="assets/bblogo.png" alt="BounceBack Logo" class="login-navbar__logo login-navbar__logo--bb" />
          </a>
        </div>
        <div class="login-navbar__right">
          <img src="assets/cmhalogo.png" alt="CMHA logo" class="login-navbar__logo login-navbar__logo--cmha" />
          <img src="assets/llttflogo.png" alt="Living Life to the Full logo" class="login-navbar__logo login-navbar__logo--llttf" />
        </div>
      </div>
    </mat-toolbar>
  </div>
</div>
